import { ReactElement } from 'react';
import { isLoggedIn, startLogin } from '../../util/auth';

interface Props {
  children: ReactElement;
}

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  if (!isLoggedIn()) {
    startLogin();
    return null;
  }

  return children;
};

export default ProtectedRoute;
